import { defineMessages } from '@jutro/locale';

export default defineMessages({
    yourComparison: {
        id: 'ml.gateway.views.ActivityReports.MLDiffDialogModal.Your Comparison',
        defaultMessage: 'Your Comparison'
    },
    closeModal: {
        id: 'ml.gateway.views.ActivityReports.MLDiffDialogModal.CLOSE',
        defaultMessage: 'CLOSE'
    },
    policyEffectiveDate: {
        id: 'ml.gateway.views.ActivityReports.MLDiffDialogModal.POLICY EFFECTIVE DATE X',
        defaultMessage: 'POLICY EFFECTIVE DATE {date}'
    }
});
